<template>
  <div>
    <b-dropdown position="is-bottom-left" append-to-body aria-role="menu" trap-focus ref="filterRef">
      <b-button
        slot="trigger"
        type="is-info"
        icon-left="filter">
          Filtrar
      </b-button>
      <b-dropdown-item
        aria-role="menu-item"
        :focusable="false"
        custom
        paddingless>
          <form action="">
            <!-- <header class="modal-card-head filter-content-padding">
            </header> -->
            <div class="modal-card" style="width:auto; overflow:visible;">
                <section class="modal-card-body filter-content-padding" style="overflow:visible;">
                  <b-field>
                    <date-picker-range :inline="false" :from.sync="filters.from" :to.sync="filters.to"/>
                  </b-field>
                </section>
                <footer class="modal-card-foot filter-content-padding" style="justify-content: center;">
                  <b-button type="is-danger" rounded expanded @click="restart" aria-role="menu-item">Restaurar</b-button>
                  <b-button type="is-primary" rounded expanded @click="apply" aria-role="menu-item">Aplicar</b-button>
                </footer>
            </div>
          </form>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import DatePickerRange from '@/components/controls/DatePickerRange'
import EventfilterService from '@/services/filters/EventFilterService'

export default {
  components: {
    DatePickerRange
  },
  created () {
    this.initFilters()
  },
  data () {
    return {
      filters: {
        from: new Date(),
        to: new Date()
      }
    }
  },
  methods: {
    initFilters () {
      this.filters = EventfilterService.getFilters(this.$route.query)
      this.apply()
    },
    apply () {
      let formatedFilters = this.getFormatedFilters()
      EventfilterService.setStorageFilters(formatedFilters)
      this.updateParams()
      this.$emit('filtered', formatedFilters)
      if (this.$refs.filterRef) {
        this.$refs.filterRef.toggle()
      }
    },
    restart () {
      this.filters = {
        from: this.$moment().startOf('month').toDate(),
        to: this.$moment().endOf('month').toDate()
      }
      this.apply()
    },
    getFormatedFilters () {
      let filters = {
        from: this.fromFormated,
        to: this.toFormated
      }
      return filters
    },
    updateParams () {
      let queryParams = this.getFormatedFilters()
      // eslint-disable-next-line handle-callback-err
      this.$router.replace({ query: queryParams }).catch(err => {})
    }
  },
  computed: {
    fromFormated () {
      return this.$moment(this.filters.from).format('YYYY-MM-DD')
    },
    toFormated () {
      return this.$moment(this.filters.to).format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped>
  .dropdown-content{
   /* padding-top: 0px !important; */
    padding-bottom: 0px !important;
    -webkit-box-shadow: 0px 4px 9px 2px rgba(0,0,0,0.3);
    -moz-box-shadow: 0px 4px 9px 2px rgba(0,0,0,0.3);
    box-shadow: 0px 4px 9px 2px rgba(0,0,0,0.3);
  }
  .filter-content-padding{
    padding: 10px 15px;
  }

  .is-grouped{
    margin-bottom: 0px !important;
  }

  .select select option:disabled {
    color: #BDBDBD !important;
  }
</style>
